export default __webpack_public_path__ + "static/media/instagram.fa410fb0.svg";